import dayjs from "dayjs";
import { useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { getValueFromInput } from "../../../components/funcForInput";
import { ApiEndpoints, reqPost, reqPostDownloadFile } from "../../../config/apiClient";

export default function FormDownloadRelatorioFolhaPontoManual({ apuracao }: iProps) {
    const [loading, setLoading] = useState<boolean>(false);
    const [downloadProgress, setDownloadProgress] = useState<number>(0);

    async function download() {
        setLoading(true);
        setDownloadProgress(0);

        let ids_colaboradores = parseColaboradores(apuracao);
        let dadosAux = {
            ids_colaborador: ids_colaboradores,
            data_inicial: getValueFromInput("data_inicial"),
            data_final: getValueFromInput("data_final"),
            width: process.env.REACT_APP_ENV_CONFIG === 'dev' ? "17in" : "23in",
            height: process.env.REACT_APP_ENV_CONFIG === 'dev' ? "25in" : "33in",
            download_tipo: "arquivo",
        };
        if (ids_colaboradores.length === 1) {
            let arquivo: string = "";
            let colaborador = apuracao.filter((reg: any) => reg.id_colaborador === dadosAux.ids_colaborador[0].toString())[0];
            arquivo = `Folha-Ponto-Manual-${colaborador.colaborador}-${dayjs(dadosAux.data_inicial).format("MM-YYYY")}.pdf`;
            setDownloadProgress(50);
            let response = await reqPostDownloadFile(ApiEndpoints.apuracaoDownloadFolhaPontoManual, dadosAux, arquivo);
            if (response.status === 200) {
                setDownloadProgress(100);
                toast.success("Aguarde o termino do download...", {
                    containerId: 1,
                    position: "top-center",
                    theme: "dark",
                });
            } else {
                toast.error("Erro no download, tente mais tarde ou verifique com o suporte!", {
                    containerId: 1,
                    position: "top-center",
                    theme: "dark",
                });
            }
            setLoading(false);
            setDownloadProgress(0);
            return;
        }

        let arquivos:string[] = []
        let erro = false
        const totalColaboradores = ids_colaboradores.length;
        for (let index = 0; index < ids_colaboradores.length; index++) {
            const id_colaborador = ids_colaboradores[index];
            let dadosAux = {
                ids_colaborador: [Number(id_colaborador)],
                data_inicial: getValueFromInput("data_inicial"),
                data_final: getValueFromInput("data_final"),
                width: process.env.REACT_APP_ENV_CONFIG === 'dev' ? "17in" : "23in",
                height: process.env.REACT_APP_ENV_CONFIG === 'dev' ? "25in" : "33in",
                download_tipo: "path",
            };
            let api = await reqPost(ApiEndpoints.apuracaoDownloadFolhaPontoManual, dadosAux)
            if (api.status === 200) {
                let folhas = api.data
                arquivos.push(folhas[0])
                setDownloadProgress(Math.round((index + 1) / totalColaboradores * 80));
            } else {
                console.log(api)
                if (api.status === 400) {
                    toast.error(api.data.message, {
                        containerId: 1,
                        position: 'top-center',
                        theme: 'dark'
                    })
                } else {
                    toast.error('Erro no download, tente mais tarde ou verifique com o suporte!', {
                        containerId: 1,
                        position: 'top-center',
                        theme: 'dark'
                    })
                }
                erro = true
                break
            }
        }

        if (erro) {
            setLoading(false)
            return
        }

        let dadosVarios:any = {
            paths: arquivos
        }
        let arquivo:string = `Folhas-Ponto-Manual-${dayjs(dadosAux.data_inicial).format("MM-YYYY")}.zip`
        console.log(dadosVarios)
        setDownloadProgress(90);
        let response = await reqPostDownloadFile(ApiEndpoints.apuracaoCalcularDadosDownloadVarios, dadosVarios, arquivo)
        if (response.status === 200) {
            setDownloadProgress(100);
            toast.success('Aguarde o termino do download...', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        } else {
            toast.error('Erro no download, tente mais tarde ou verifique com o suporte!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }

        setLoading(false);
        setDownloadProgress(0);
    }
    function parseColaboradores(dados: any[]) {
        let ids: number[] = [];
        for (let reg of dados) {
            ids.push(Number(reg.id_colaborador));
        }
        return ids;
    }

    return (
        <div>
            <br />
            <p>Colaboradores Selecionados ({apuracao.length})</p>
            <br />
            <div className="div-row">
                <Button type="submit" variant="success" disabled={loading} style={{ marginRight: "5px" }} onClick={(e) => download()}>
                    {loading ? "Aguarde..." : "Download"}
                </Button>
            </div>
            <br></br>
            {loading && (
                <div className="div-row" style={{ alignItems: "center", gap: "10px" }}>
                    <Spinner />
                    <span style={{ fontSize: "14px", color: "#6c757d" }}>
                        Baixando {downloadProgress}%
                    </span>
                </div>
            )}
        </div>
    );
}
interface iProps {
    apuracao: any;
}
